var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooksDuotone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.09,
    height: 30.092,
    viewBox: "0 0 30.09 30.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "books-duotone",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17720",
    "data-name": "Path 17720",
    d: "M0,7.525H7.523V5.644H0ZM0,24.452H7.523V22.624L0,22.571Zm9.4,0h7.47V22.624H9.4Zm20.624,2.31-.969-3.625-7.212,1.942.966,3.624A1.869,1.869,0,0,0,25.1,30.03l3.6-.971A1.883,1.883,0,0,0,30.027,26.761ZM24.714,6.831,17.5,8.771l3.866,14.5,7.212-1.942ZM23.263,1.392A1.869,1.869,0,0,0,20.976.066l-3.607.971a1.88,1.88,0,0,0-1.32,2.3l.616,2.31H9.4V7.525h7.47v-.9l.09.336,7.212-1.942Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17721",
    "data-name": "Path 17721",
    d: "M0,22.572H7.523V7.526H0ZM5.642,0H1.828A1.874,1.874,0,0,0,0,1.883V5.592H7.523V1.883A1.885,1.885,0,0,0,5.642,0ZM0,28.161a1.828,1.828,0,0,0,1.828,1.828H5.589a1.828,1.828,0,0,0,1.828-1.828l.106-3.709H0ZM24.232,5.017,17.015,6.961,17.5,8.773,24.71,6.832Zm4.343,16.308-7.212,1.942.483,1.812,7.212-1.942ZM9.4,22.572h7.47V7.526H9.4Zm0,5.589a1.84,1.84,0,0,0,1.881,1.828h3.709a1.808,1.808,0,0,0,1.828-1.88V24.347H9.351ZM16.051,3.336a1.868,1.868,0,0,1,.762-2.018A1.863,1.863,0,0,0,15.047,0H11.339A1.874,1.874,0,0,0,9.458,1.831L9.4,5.645h7.264Z",
    transform: "translate(0 -0.001)",
    opacity: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooksDuotone);
export default __webpack_public_path__ + "static/media/books-duotone.d54c5235113dafac55ef41bc8089ac90.svg";
export { ForwardRef as ReactComponent };